import { render, staticRenderFns } from "./Offer.vue?vue&type=template&id=6b52129a&scoped=true"
import script from "./Offer.vue?vue&type=script&lang=js"
export * from "./Offer.vue?vue&type=script&lang=js"
import style0 from "./Offer.vue?vue&type=style&index=0&id=6b52129a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b52129a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b52129a')) {
      api.createRecord('6b52129a', component.options)
    } else {
      api.reload('6b52129a', component.options)
    }
    module.hot.accept("./Offer.vue?vue&type=template&id=6b52129a&scoped=true", function () {
      api.rerender('6b52129a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/prepayments/Offer.vue"
export default component.exports